var map = {
	"app/private/backoffice-products/backoffice-products.module": [
		"../../../../../src/app/private/backoffice-products/backoffice-products.module.ts",
		"backoffice-products.module"
	],
	"app/private/categorias-producto/categorias-producto.module": [
		"../../../../../src/app/private/categorias-producto/categorias-producto.module.ts",
		"categorias-producto.module"
	],
	"app/private/diagnosticos/diagnosticos.module": [
		"../../../../../src/app/private/diagnosticos/diagnosticos.module.ts",
		"diagnosticos.module",
		"common"
	],
	"app/private/product-email/product-email.module": [
		"../../../../../src/app/private/product-email/product-email.module.ts",
		"product-email.module"
	],
	"app/private/providers/providers.module": [
		"../../../../../src/app/private/providers/providers.module.ts",
		"providers.module"
	],
	"app/private/restaurarEntidades/restaurar-entidades.module": [
		"../../../../../src/app/private/restaurarEntidades/restaurar-entidades.module.ts",
		"restaurar-entidades.module"
	],
	"app/private/sponsor/sponsor.module": [
		"../../../../../src/app/private/sponsor/sponsor.module.ts",
		"sponsor.module"
	],
	"app/private/testApi/testApi.module": [
		"../../../../../src/app/private/testApi/testApi.module.ts",
		"testApi.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main